import { useEffect } from "react";
import { comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useFetch, useToast, useModal, usePage } from "@/comn/hooks";
import { URLS, APIS, SF_MSG_LANG } from "./services/MsgLangPrsccService";
import { useNavigate, useParams } from "react-router-dom";

export const OSCI0111010S = () => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003"],
    });
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { msgId } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    const form = {
        msgLang: useForm({
            defaultSchema: SF_MSG_LANG,
            defaultValues: {},
        }),
    };

    const fetch = {
        getMsgLang: useFetch({
            api: () => APIS.getMsgLang(msgId),
            enabled: !!msgId,
            onSuccess: (data) => {
                const msgLang = data.msgLang.content;
                const msgLangInfoList = msgLang.msgLangInfoList;

                if (msgLangInfoList) {
                    msgLangInfoList.map((item: any) => {
                        switch (item.langCd) {
                            case "EN":
                                msgLang.msgCnEn = item.msgCn;
                                break;
                            case "TZ":
                                msgLang.msgCnTz = item.msgCn;
                                break;
                            default:
                                msgLang.msgCnKo = item.msgCn;
                                break;
                        }
                    });
                }
                form.msgLang.setValues(msgLang);
            },
            onError: () => {},
            showToast: true,
        }),
        saveMsgLang: useFetch({
            api: (msgIds) => APIS.saveMsgLang(msgIds),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.osc.00006",
                    onCancel: () => {
                        navigate(`${URLS.osci0111008q}/${msgId}`);
                    },
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };

    const handler = {
        saveMsgLang: form.msgLang.handleSubmit(
            () => {
                const data = form.msgLang.getValues();
                modal.openModal({
                    content: "msg.osc.00090",
                    onConfirm: () => {
                        fetch.saveMsgLang.fetch(data);
                    },
                });
            },
            () => {
                toast.showToast({ type: "warning", content: "msg.osc.00003" });
            },
        ),
    };

    useEffect(() => {
        fetch.getMsgLang.fetch();
        form.msgLang.setSchema("msgId", { edit: false });
        form.msgLang.setSchema("bsopClsfCd", { edit: false });
    }, []);

    return (
        <Page {...(comnUtils.isEmpty(menuId) ? { pgeUid: pgeUid, info: true } : {})}>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.msgLang.schema.msgId}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.msgLang.schema.bsopClsfCd}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.msgLang.schema.msgCnEn}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.msgLang.schema.msgCnTz}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.msgLang.schema.msgCnKo}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            </form>
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(`${URLS.osci0111007q}`);
                        }}
                    ></Button>
                </Layout.Left>
                <Layout.Right>
                    <Button
                        role="save"
                        onClick={() => {
                            handler.saveMsgLang();
                        }}
                    ></Button>
                    <Button
                        role="cancel"
                        onClick={() => {
                            navigate(`${URLS.osci0111008q}/${msgId}`);
                        }}
                    ></Button>
                </Layout.Right>
            </Layout>
        </Page>
    );
};
